export default "__VITE_ASSET__DBE9MfAp__"